import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { GeneralService } from 'src/app/service/general.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  receivedEmail: string = '';
  receivedPassword: string = '';
  errorMessage: string = '';
  signinSuccess: boolean = false;
  processLoading: boolean = false;

  constructor(private authService: AuthService,
     private router: Router,
     private generalService: GeneralService,
     ) {}

  ngOnInit(): void {
  }


  login(){
    this.router.navigate(['signin']);
  }

  email(data: string) {
    this.receivedEmail = data;
  }

  resetPassword = () => {
    this.processLoading = true;
    const email = {
    "emailAddress":this.receivedEmail,
    }
    // console.log(this.receivedEmail)
    this.errorMessage = "";
    const isValid = this.authService.validateEmail(this.receivedEmail)
    if (!isValid){
      this.errorMessage = "please enter a valid email address";
      this.processLoading = false;
    }
    this.authService.resetPassword(email).subscribe((res: any) => {
      // if(!this.authService.validateEmailAddress(this.receivedEmail)){
      //   this.errorMessage = "Invalid Email Address"
      //   this.processLoading = false;
      //   return;
      // }
      if (res.statusCode === 200) {
        this.processLoading = false;
        // this.generalService.setToken(res.data.accessToken);
        this.signinSuccess = true;
        // console.log ('password reset successfully')
        this.router.navigate(['signin']);
        setTimeout(() => {
          this.processLoading = false;
        }, 2000);
      } else {
        this.processLoading = false;
        this.errorMessage = 'Problem resetting password'
      }
    });
  }
}
